import { combineReducers } from 'redux';
import aesReduxConstants from '../constants';

const mapInspectReducer = function() {
  const constants = aesReduxConstants.MAP_INSPECT;

  const resultsReducer = function(state, action) {
    const defaultState = [];
    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.INSPECT_LOCATION_SUCCESS:
        return action.results;

      default:
        return state;
    }
  };

  const areaReducer = function(state, action) {
    const defaultState = [];
    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.INSPECT_LOCATION_SUCCESS:
        return action.area;

      default:
        return state;
    }
  };

  const loadingReducer = function(state, action) {
    const defaultState = false;
    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.INSPECT_LOCATION:
        return true;
      case constants.INSPECT_LOCATION_SUCCESS:
      case constants.INSPECT_LOCATION_ERROR:
        return false;

      default:
        return state;
    }
  };

  const errorMessageReducer = function(state, action) {
    const defaultState = {
      title: null,
      details: null,
    };

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.INSPECT_LOCATION_ERROR:
        return action.errorMessage;

      case constants.INSPECT_LOCATION:
        return defaultState;

      default:
        return state;
    }
  };

  const settingsReducer = function(state, action) {
    const defaultState = {
      inspectionArea: {
        lat: null,
        lon: null,
        radius: null,
        imageDisplay: null,
        extent: null,
      },
      mapLayers: [],
    };

    if (state === undefined) state = defaultState;

    switch (action.type) {
      case constants.UPDATE_INSPECT_LOCATION_SETTINGS:
        return action.settings;
      default:
        return state;
    }
  };

  return combineReducers({
    area: areaReducer,
    results: resultsReducer,
    isLoading: loadingReducer,
    errorMessage: errorMessageReducer,
    settings: settingsReducer,
  });
};

export default mapInspectReducer();
